import type { SessionHistoryResponse, SessionInfo, SessionListResponse } from '../types/api';
import { fetchWithTimeout } from './http';

const BASE = import.meta.env.VITE_API_BASE_URL ?? '';

export async function fetchSessions(
  limit = 50,
  offset = 0,
  q?: string,
): Promise<SessionListResponse> {
  const params = new URLSearchParams({ limit: String(limit), offset: String(offset) });
  if (q) params.set('q', q);
  const res = await fetchWithTimeout(`${BASE}/api/v1/sessions?${params}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<SessionListResponse>;
}

export async function fetchSessionHistory(sessionId: string): Promise<SessionHistoryResponse> {
  const res = await fetchWithTimeout(
    `${BASE}/api/v1/sessions/${encodeURIComponent(sessionId)}/history`,
  );
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<SessionHistoryResponse>;
}

export async function renameSession(sessionId: string, title: string): Promise<SessionInfo> {
  const res = await fetchWithTimeout(`${BASE}/api/v1/sessions/${encodeURIComponent(sessionId)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ title }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<SessionInfo>;
}

export async function deleteSession(sessionId: string): Promise<void> {
  const res = await fetchWithTimeout(`${BASE}/api/v1/sessions/${encodeURIComponent(sessionId)}`, {
    method: 'DELETE',
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
}
